<template>
  <!-- 論点候補 -->

  <modal
    name="issue"
    :draggable="true"
    :resizable="true"
    :min-width="1200"
    :min-height="400"
    width="70%"
    height="70%"
    :scrollable="true"
    :click-to-close="false"
  >
    <div class="modal-header modalDialog-header">
      <div style="margin-left: 5px; padding-top: 3px">論点候補</div>
      <button
        type="button"
        class="btn-close"
        style="margin-right: 3px; padding-top: 6px"
        @click="closeModal"
      ></button>
    </div>
    <div class="modal-body">
      <div style="padding: 0 15px 0 15px">
        <div v-for="(item, index) in optionsONE" :key="index" class="mtp-4">
          <div class="mtp-3 titlemain">
            <div class="title">
              {{ item.test }}
            </div>
            <div
              v-for="(item1, index1) in item.children"
              :key="index1"
              class="mtp-3"
            >
              <div v-show="item1.test != ''">
                <!-- 総論   各論 -->
                <div class="d-flex align-items-center ms-2" style="">
                  【

                  <div
                    v-if="item1.showInput == false"
                    class="d-flex align-items-center"
                    style="margin: 0 5px"
                  >
                    {{ item1.test }}
                  </div>

                  】
                </div>
              </div>

              <div class="titlesub">
                <div
                  v-for="(item2, index2) in item1.children"
                  :key="index2"
                  class="d-flex align-items-center"
                  style="min-width: px"
                >
                  &emsp;
                  <div>
                    <input
                      :id="item.test + item1.test + item2.aa"
                      v-model="item2.isTrue"
                      class="form-check-input"
                      style="margin-right: 5px"
                      type="checkbox"
                    />
                  </div>
                  <label
                    v-if="item2.showInput == false"
                    :for="item.test + item1.test + item2.aa"
                    >{{ item2.aa }}</label
                  >

                  <div class="d-flex align-items-center"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex mtp-3 mbm-3" style="justify-content: center">
        <ButtonMain
          button-name="登録"
          @click="create"
        ></ButtonMain>
        <div class="ms-4"></div>
        <ButtonNormal
          button-name="キャンセル"
          @click="cancel"
        ></ButtonNormal>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'IssueCandidateDialog',
  props: {
    optionsONE: Array
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    create() {
      this.$emit('IssueCandidateRegistration')
    },
    cancel() {
      this.$emit('IssueCandidateRegistration')
    }
  }
}
</script>

<style scoped lang="scss">
.modalDialog-header {
  background: rgb(229, 235, 250);
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
  border-radius: 5px 5px 0 0;
  z-index: 1100 !important;
}
.titlemain {
  padding: 0 10px 10px 10px;
  position: relative;
  border: 1px solid rgb(177, 177, 177);

  .title {
    display: inline;
    background: #fff;
    position: absolute;
    top: -13px;
    padding: 0 5px;
  }

  .titlesub {
    width: 98%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
}
</style>
